import initMK from '../_core/init.js';
import defineProp from '../_core/defineprop.js';
import forOwn from '../_helpers/forown.js';
import set from '../set.js';
import is from '../_helpers/is.js';
import forEach from '../_helpers/foreach.js';
import triggerOne from '../trigger/_triggerone.js';
import hasOwn from '../_helpers/hasown.js';
import fromEntries from '../_helpers/fromentries.js';
import assign from '../_helpers/assign.js';
// returns an array of keys listed at inObject but not listed at fromObject
function getNotListedKeys(inObject, fromObject) {
  var result = [];
  forOwn(inObject, function (_, key) {
    if (!hasOwn(fromObject, key)) {
      result.push(key);
    }
  });
  return result;
}
// removes data keys; "silent" skips remove and modify, as remove() does
function removeKeys(object, keys, removed, silent) {
  forEach(removed, function (key) {
    var eventOptions = {
      key: key,
      value: object[key]
    };
    delete keys[key];
    triggerOne(object, '_asterisk:remove', eventOptions);
    if (!silent) {
      triggerOne(object, 'remove', eventOptions);
      triggerOne(object, 'modify', eventOptions);
    }
  });
}
// makes a key a data key and sets its value; a value the key already holds still becomes data, as addDataKeys does
function setOne(object, keys, key, value, eventOptions) {
  var isNew = !(key in keys);
  defineProp(object, key);
  keys[key] = 1;
  if (isNew && is(object[key], value)) {
    var extendedEventOptions = assign({}, eventOptions, {
      key: key,
      value: value
    });
    triggerOne(object, '_asterisk:set', extendedEventOptions);
    // with force, set() fires them itself
    if (!eventOptions.silent && !eventOptions.force) {
      triggerOne(object, 'set', extendedEventOptions);
      triggerOne(object, 'modify', extendedEventOptions);
    }
  }
  return set(object, key, value, eventOptions);
}
// changes property value and adds given key to a list of data keys
export default function setData(key, value, eventOptions) {
  var _this = this;
  // if no key or falsy key is given
  if (!key) {
    return this;
  }
  var _initMK = initMK(this),
    keys = _initMK.keys;
  // allow to pass key-value object
  if (typeof key === 'object') {
    eventOptions = value || {};
    // a Matreshka.Object gives its data, not its own fields such as nodes
    var data = key.isMatreshkaObject ? fromEntries(key.entries()) : key;
    // remove data keys not listed at key-value object
    if (eventOptions.replaceData) {
      removeKeys(this, keys, getNotListedKeys(keys, data), eventOptions.silent);
    }
    forOwn(data, function (objVal, objKey) {
      setOne(_this, keys, objKey, objVal, eventOptions);
    });
    return this;
  }
  eventOptions = eventOptions || {};
  // remove all data keys except given key
  if (eventOptions.replaceData) {
    removeKeys(this, keys, getNotListedKeys(keys, fromEntries([[key, true]])), eventOptions.silent);
  }
  return setOne(this, keys, key, value, eventOptions);
}